import FirstRoundLetterComp from "components/FirstRoundLetter/FirstRoundLetter";
import CommonTooltip from "components/Tooltip/CommonTooltip";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import avatar5 from "../../../assets/img/avatar_5.svg";
import NoDataComponent from "../../../components/NoDataComponent/NoDataComponent";
import RoundImageNameComp from "../../../components/RoundImageName/RoundImageNameComp";
import {
  CenteredTooltip,
  CommonFlex,
  SingleAssigneeRoundImage,
} from "../../../styledComponents/common";
import {
  SingleItemTime,
  SingleItemTimeText,
  SingleItemTotal,
  SingleItemTotalAuto,
  SingleItemUserAvatar,
  SingleItemUserDiv,
  SingleItemUserName,
  TableBodySingleItemContainer,
  TableHeadDate,
  TableHeadDateContainer,
  TableHeadDayText,
  TableHeadMonthText,
  TableHeadText,
  WeeklyDetailsTableBodyContainer,
  WeeklyDetailsTableContainer,
  WeeklyDetailsTableHeadContainer,
  WeeklyTotal,
} from "../../../styledComponents/timesheet";
import {
  formatHmsString,
  getHours,
  getHoursWithSeconds,
  toHHMMSS,
} from "../../../utils/helper";
import {
  SingleAssigneeRoundImageComp,
  UserDotCircle,
} from "../../LiveFeed/CurrentlyTracking/currentlyTrackingStyles";
import { HmsDisplay } from "../HmsDisplay";
import { TimeDisplay } from "../TimeDisplay";

const getDates = date => {
  const dateList = [];
  let startDate = moment(date).startOf("week");
  while (moment(startDate).isSameOrBefore(moment(date).endOf("week"))) {
    dateList.push(startDate);
    startDate = moment(startDate).add(1, "days");
  }
  return dateList;
};

const getTimes = date => {
  const times = [];
  let startDate = moment(date).startOf("week");
  while (moment(startDate).isSameOrBefore(moment(date).endOf("week"))) {
    times.push({
      date: startDate,
      hours: "0 h 0 m",
    });
    startDate = moment(startDate).add(1, "days");
  }
  return times;
};

const SingleRow = ({
  memberData,
  handleGetDetails,
  getHours,
  detailsUserData,
  setDetailsUserData,
  index,
  setSelectedPanelDate,
  activeDate,
  isDetailsOpen,
}) => {
  return (
    <TableBodySingleItemContainer>
      <SingleItemUserDiv>
        <RoundImageNameComp
          {...{
            imgSource: memberData.avatar,
            name: memberData.name,
            index,
            imageSize: "32px",
            color: memberData.color,
            fontSize: "14px",
            fontWeight: "500",
            isOnline: memberData.isOnline,
            userId:memberData.user_id,
          }}
        />

        {/* <SingleItemUserName>{memberData.name}</SingleItemUserName> */}
      </SingleItemUserDiv>
      {memberData.timesheet && memberData.timesheet.length > 0 && (
        <>
          {memberData.timesheet.map((timesheet, index) => (
            <SingleItemTime
              key={index}
              fontSize="13.5px"
              onClick={() => {
                if (timesheet.hours !== "0 h 0 m") {
                  handleGetDetails(timesheet.date, memberData.user_id);
                  setSelectedPanelDate(
                    moment(timesheet.date).format("YYYY-MM-DD"),
                  );
                  setDetailsUserData({
                    id: memberData.user_id,
                    name: memberData.name,
                    avatar: memberData.avatar,
                    color: memberData.color,
                    date: timesheet.date,
                    totalTime: timesheet.hours,
                  });
                }
              }}
              hasTime={timesheet.hours !== "0 h 0 m"}
              largerZ={isDetailsOpen}
            >
              <SingleItemTimeText
                isActive={
                  activeDate === moment(timesheet.date).format("YYYY-MM-DD") &&
                  isDetailsOpen &&
                  memberData.user_id === detailsUserData.id
                }
              >
                {timesheet.hours === "0 h 00 m" ||
                timesheet.hours === "0 h 0 m" ? (
                  "-"
                ) : (
                  <CommonTooltip tooltipText={formatHmsString(timesheet.hours)}>
                    <HmsDisplay timeString={timesheet.hours} />
                  </CommonTooltip>
                )}
              </SingleItemTimeText>
            </SingleItemTime>
          ))}
          <SingleItemTime>
            <SingleItemTotalAuto fontSize="13.5px">
              {memberData.durations ? (
                <CommonTooltip tooltipText={formatHmsString(getHoursWithSeconds(
                    toHHMMSS(
                      memberData.durations
                        .slice(1)
                        .reduce(
                          (prev, cur) => cur + prev,
                          memberData.durations[0],
                        ),
                    ),
                  ))}>
                <TimeDisplay marginLeft="0px" 
                  timeString={getHoursWithSeconds(
                    toHHMMSS(
                      memberData.durations
                        .slice(1)
                        .reduce(
                          (prev, cur) => cur + prev,
                          memberData.durations[0],
                        ),
                    ),
                  )}
                ></TimeDisplay>
                </CommonTooltip>
              ) : (
                "-"
              )}
            </SingleItemTotalAuto>
          </SingleItemTime>
        </>
      )}
    </TableBodySingleItemContainer>
  );
};

const WeeklyAdminView = props => {
  const [timesheetsData, setTimesheetsData] = useState([]);
  const [dates, setDates] = useState([]);

  const {
    selectedDate,
    membersList,
    timesheetsList,

    getTimesheetDetails,
    detailsUserData,
    setDetailsUserData,
    selectedPanelDate,
    setSelectedPanelDate,
    activeDate,
    setActiveDate,
    isDetailsOpen,
    onlineMembers,
  } = props;
  const calculateTotalHours = () => {
    if (!timesheetsList || typeof timesheetsList !== "object") {
      return 0;
    }

    let totalDuration = 0;
    Object.values(timesheetsList).forEach(timesheet => {
      if (Array.isArray(timesheet)) {
        timesheet.forEach(entry => {
          totalDuration += entry.duration || 0;
        });
      }
    });

    return totalDuration;
  };
  useEffect(() => {
    setDates(getDates(selectedDate));
  }, []);

  useEffect(() => {
    setDates(getDates(selectedDate));
  }, [selectedDate]);

  useEffect(() => {
    if (membersList && membersList.length > 0 && selectedDate) {
      const timesheets = [];
      membersList.forEach(member => {
        const memberData = {
          user_id: member.id,
          name: member.name,
          avatar: member.avatar || avatar5,
          color: member.color,
          isOnline: onlineMembers.includes(member.id),
        };
        const times = getTimes(selectedDate);
        if (
          timesheetsList &&
          Object.keys(timesheetsList).length !== 0 &&
          timesheetsList.hasOwnProperty(member.id)
        ) {
          const durations = [];
          timesheetsList[member.id].forEach(timesheet => {
            durations.push(timesheet.duration);
            times.some(item => {
              if (moment(item.date).format("YYYY-MM-DD") === timesheet.date) {
                item.hours = getHoursWithSeconds(toHHMMSS(timesheet.duration));
                return true;
              }
              return false;
            });
            if (
              detailsUserData &&
              detailsUserData.id === member.id &&
              detailsUserData.date &&
              moment(detailsUserData.date).format("YYYY-MM-DD") ===
                timesheet.date
            ) {
              setDetailsUserData({
                ...detailsUserData,
                totalTime: getHoursWithSeconds(toHHMMSS(timesheet.duration)),
              });
            }
          });
          memberData.durations = durations;
          memberData.timesheet = [...times];
        } else {
          memberData.timesheet = times;
        }
        timesheets.push({ ...memberData });
      });
      setTimesheetsData([...timesheets]);
    } else if (membersList && membersList.length === 0) {
      // no data
      setTimesheetsData([]);
    }
  }, [timesheetsList, membersList]);

  useEffect(() => {
    setActiveDate(selectedPanelDate);
  }, [selectedPanelDate]);

  const sharedMonths = Array.from(new Set(dates.map(d => d.format("MMM"))));
  return (
    <WeeklyDetailsTableContainer>
      {timesheetsData && timesheetsData.length > 0 ? (
        <>
          <WeeklyDetailsTableHeadContainer alignItems="start">
            <TableHeadDateContainer>
              <TableHeadText margin="0 0 0 0">Members</TableHeadText>
              <TableHeadText
                fontSize="16px"
                fontWeight="600"
                margin="5px 0 0 0"
                color="#3d4d69"
              >
                {timesheetsData.length}
              </TableHeadText>
            </TableHeadDateContainer>
            {dates &&
              dates.length > 0 &&
              dates.map((date, index) => {
                const isFirst = index === 0;
                const isMonthStart = date.date() === 1;
                const showMonth =
                  sharedMonths.length > 1 && (isFirst || isMonthStart);
                return (
                  <TableHeadDateContainer key={index}>
                    <TableHeadDayText>{date.format("ddd")}</TableHeadDayText>
                    <TableHeadDate today={moment().isSame(date, "day")}>
                      {date.format("D")}
                    </TableHeadDate>
                    <TableHeadMonthText
                      style={{
                        visibility: showMonth ? "visible" : "hidden",
                      }}
                    >
                      {date.format("MMMM")}
                    </TableHeadMonthText>
                  </TableHeadDateContainer>
                );
              })}
            <TableHeadDateContainer>
              <TableHeadText margin="0 0 0 0">Total Hours</TableHeadText>
              <WeeklyTotal
                style={{
                  marginTop: "5px",
                  marginBottom: "0",
                  width: "max-content",
                  padding:"10px",
                  overflow: "visible",
                  minWidth: "60px",
                  maxWidth: "150px",

                }}
              >
                {calculateTotalHours() > 0 ? (
                    <TimeDisplay
                      timeString={getHoursWithSeconds(
                        toHHMMSS(calculateTotalHours()),
                      )}
                      marginLeft="0px"
                    />
                ) : (
                  "-"
                )}
              </WeeklyTotal>
            </TableHeadDateContainer>
          </WeeklyDetailsTableHeadContainer>
          <WeeklyDetailsTableBodyContainer>
            {timesheetsData.map((member, index) => (
              <SingleRow
                key={index}
                memberData={member}
                getHours={getHours}
                handleGetDetails={getTimesheetDetails}
                detailsUserData={detailsUserData}
                setDetailsUserData={setDetailsUserData}
                setSelectedPanelDate={setSelectedPanelDate}
                activeDate={activeDate}
                setActiveDate={setActiveDate}
                isDetailsOpen={isDetailsOpen}
                index={index}
              />
            ))}
          </WeeklyDetailsTableBodyContainer>
        </>
      ) : timesheetsData && timesheetsData.length === 0 ? (
        <NoDataComponent title="No timesheet records found." />
      ) : null}
    </WeeklyDetailsTableContainer>
  );
};

export default WeeklyAdminView;
